import { action } from 'typesafe-actions';
import ActionTypes, { TSideBarState } from './types';

export const setSideBar = (payload: TSideBarState['page']) => action(ActionTypes.SET_SIDEBAR, payload);
